// Section 17: priority group 'Children 6 to 14'. Members are listed in sorted id order; the rationing
// phase ranks groups by the policy's order and breaks ties by lowest strength first.
import { definePriorityGroup } from '../../core/registry';
import { isChild, peopleSorted } from '../../core/queries';
import type { Config } from '../../config';

export function children6To14(_config: Config) {
  return definePriorityGroup({
    id: 'children-6-14',
    label: 'Children 6 to 14',
    section: 'S17',
    members: (ctx) =>
      peopleSorted(ctx.state)
        .filter(
          (p) =>
            p.ageSeasons >=
              ctx.cfg.rationing.youngChildUnderYears * ctx.cfg.people.seasonsPerYear &&
            isChild(ctx.cfg, p),
        )
        .map((p) => p.id),
  });
}
